import React, { CSSProperties, FC } from 'react';
import styles from './Tag.module.css';

export interface TagSvgProps {
  s?: CSSProperties;
}

const Tag: FC<TagSvgProps> = ({ s }) => (
  <svg
    className={styles.container}
    style={{ ...s }}
    viewBox="0 0 20 20"
    role="presentation"
  >
    <g clipPath="url(#clip0_227_1489)">
      <path
        d="M6.24984 6.66675C6.47996 6.66675 6.6665 6.4802 6.6665 6.25008C6.6665 6.01996 6.47996 5.83342 6.24984 5.83342C6.01972 5.83342 5.83317 6.01996 5.83317 6.25008C5.83317 6.4802 6.01972 6.66675 6.24984 6.66675Z"
        fill="currentColor"
      />
      <path
        d="M10.4882 2.15508C10.1757 1.8425 9.75183 1.66684 9.30984 1.66675H3.33317C2.89114 1.66675 2.46722 1.84234 2.15466 2.1549C1.8421 2.46746 1.6665 2.89139 1.6665 3.33341V9.31008C1.6666 9.75207 1.84225 10.1759 2.15484 10.4884L9.40817 17.7417C9.78693 18.1181 10.2992 18.3294 10.8332 18.3294C11.3671 18.3294 11.8794 18.1181 12.2582 17.7417L17.7415 12.2584C18.1179 11.8797 18.3291 11.3674 18.3291 10.8334C18.3291 10.2995 18.1179 9.78718 17.7415 9.40841L10.4882 2.15508Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24984 6.66675C6.47996 6.66675 6.6665 6.4802 6.6665 6.25008C6.6665 6.01996 6.47996 5.83342 6.24984 5.83342C6.01972 5.83342 5.83317 6.01996 5.83317 6.25008C5.83317 6.4802 6.01972 6.66675 6.24984 6.66675Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_227_1489">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Tag;
